var parent = require('../../es/map');
require('../../modules/web.dom-collections.iterator');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/map/index.js
// module id = 586
// module chunks = 0 1